import { IonButton, IonIcon, IonSpinner } from "@ionic/react";
import React, { useState } from "react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";
import ReportRow from "./ReportRow";
import { default as download_report_icon } from "../../../AE2/static/icons/download_report_icon.svg";

interface Props {
  uuid: string;
  name?: string;
  row?: boolean;
}

async function downloadReport(token: string, id: string) {
  return fetch(`${API_URL}/reports/campus_meter_summary`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      customer: id,
    }),
  }).then(async (res: any) => {
    if (res.ok) {
      return res.blob();
    } else {
      const data = await res.json().catch(() => ({}));
      return {
        error: data.error || "Could not generate report.",
      };
    }
  });
}

const CampusMeterSummaryReportButton: React.FC<Props> = ({ uuid, name, row }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res: any = await downloadReport(token, uuid);
    if (res && "error" in res) {
      NotificationPopUp("error", res["error"], "Error Generating Report");
    } else {
      const url = window.URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name || uuid}_Campus_Meter_Summary.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode!.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    setLoading(false);
  };

  if (row) {
    return <ReportRow title="Campus Summary Report" loading={loading} onClick={handleDownload} />;
  }

  return (
    <IonButton
      onClick={handleDownload}
      disabled={loading}
      title="Campus Meter Summary"
      shape="round"
      color="medium"
    >
      {loading ? (
        <IonSpinner />
      ) : (
        <IonIcon slot="icon-only" src={download_report_icon} />
      )}
    </IonButton>
  );
};

export default CampusMeterSummaryReportButton;
